// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.masterpage-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
  padding: 25px;
}

.masterpage-header {
  background-color: rgba(255, 255, 255, 0.95);
  padding: 15px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
  margin-bottom: 25px;
  backdrop-filter: blur(5px);
}

.masterpage-search-input {
  width: 100%;
  max-width: 350px;
  padding: 12px 18px;
  border: 2px solid #ced4da;
  border-radius: 25px;
  font-size: 15px;
  margin-bottom: 15px;
  background-color: #fff;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.masterpage-search-input:focus {
  border-color: #40c057;
  box-shadow: 0 0 8px rgba(64, 192, 87, 0.3);
  outline: none;
}

.masterpage-controls {
  display: flex;
  align-items: center;
  gap: 25px;
  flex-wrap: wrap;
}

.masterpage-controls label {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #343a40;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.masterpage-submit-btn {
  padding: 10px 20px;
  background-color: #40c057;
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  font-size: 15px;
  font-weight: 500;
}

.masterpage-submit-btn:hover:not(:disabled) {
  background-color: #37b24d;
  transform: translateY(-2px);
}

.masterpage-submit-btn:disabled {
  background-color: #adb5bd;
  cursor: not-allowed;
  transform: none;
}

.masterpage-content {
  padding: 0;
}

.masterpage-title {
  color: #212529;
  margin-bottom: 20px;
  font-size: clamp(22px, 5vw, 28px);
  font-weight: 600;
  text-align: center;
}

.masterpage-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.masterpage-card {
  background-color: #fff;
  border-radius: 12px;
  padding: 15px 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06);
  border-left: 5px solid #0668f9;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.masterpage-card:hover {
  transform: scale(1.02);
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
}

.masterpage-card-checkbox {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
}

.masterpage-card-checkbox input {
  appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #40c057;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s ease;
}

.masterpage-card-checkbox input:checked {
  background-color: #40c057;
}

.masterpage-card-checkbox input:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: white;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.masterpage-card-checkbox strong {
  color: #212529;
  font-size: 16px;
  font-weight: 600;
}

.masterpage-card p {
  margin: 8px 0;
  color: #495057;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.masterpage-card p strong {
  color: #343a40;
  font-weight: 500;
  min-width: 100px;
}

.masterpage-card p span {
  color: #6c757d;
  flex: 1 1;
  word-break: break-word;
}

@media (max-width: 768px) {
  .masterpage-wrapper {
    padding: 15px;
  }

  .masterpage-header {
    padding: 12px 15px;
  }

  .masterpage-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .masterpage-grid {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }
}

@media (max-width: 480px) {
  .masterpage-header {
    padding: 10px;
  }

  .masterpage-search-input {
    max-width: 100%;
  }

  .masterpage-grid {
    grid-template-columns: 1fr;
  }

  .masterpage-card {
    padding: 12px 15px;
  }

  .masterpage-card p {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .masterpage-card p strong {
    min-width: auto;
  }
}

.masterpage_table-wrapper {
  width: 100%;
  overflow-x: auto;
  font-family: "Poppins", sans-serif;
}

.masterpage_table-scroll {
  max-height: 400px;
  overflow: auto;
  border: 1px solid #ddd;
}

.masterpage_table {
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
}

.masterpage_table th,
.masterpage_table td {
  padding: 12px 3px;
  text-align: left;
  border: 1px solid #ddd;
  white-space: nowrap;
}

.masterpage_table thead th {
  position: sticky;
  top: 0;
  background: linear-gradient(90deg, #ff6b6b, #ff8e53);
  color: white;
  z-index: 2;
}

.masterpage_table-row:hover {
  background-color: #f9f9f9;
  transition: background-color 0.3s ease;
}

.masterpage_table-already-sent {
  background-color: #f2f2f2 !important;
  opacity: 0.6;
}

/* Responsive Tweaks */
@media screen and (max-width: 768px) {
  .masterpage_table th,
  .masterpage_table td {
    font-size: 12px;
  }
}

@media screen and (max-width: 480px) {
  .masterpage_table th,
  .masterpage_table td {
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Perches/masterpage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,oDAAoD;EACpD,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".masterpage-wrapper {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);\n  padding: 25px;\n}\n\n.masterpage-header {\n  background-color: rgba(255, 255, 255, 0.95);\n  padding: 15px 20px;\n  border-radius: 12px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);\n  margin-bottom: 25px;\n  backdrop-filter: blur(5px);\n}\n\n.masterpage-search-input {\n  width: 100%;\n  max-width: 350px;\n  padding: 12px 18px;\n  border: 2px solid #ced4da;\n  border-radius: 25px;\n  font-size: 15px;\n  margin-bottom: 15px;\n  background-color: #fff;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.masterpage-search-input:focus {\n  border-color: #40c057;\n  box-shadow: 0 0 8px rgba(64, 192, 87, 0.3);\n  outline: none;\n}\n\n.masterpage-controls {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n  flex-wrap: wrap;\n}\n\n.masterpage-controls label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #343a40;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.masterpage-submit-btn {\n  padding: 10px 20px;\n  background-color: #40c057;\n  color: white;\n  border: none;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.masterpage-submit-btn:hover:not(:disabled) {\n  background-color: #37b24d;\n  transform: translateY(-2px);\n}\n\n.masterpage-submit-btn:disabled {\n  background-color: #adb5bd;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.masterpage-content {\n  padding: 0;\n}\n\n.masterpage-title {\n  color: #212529;\n  margin-bottom: 20px;\n  font-size: clamp(22px, 5vw, 28px);\n  font-weight: 600;\n  text-align: center;\n}\n\n.masterpage-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.masterpage-card {\n  background-color: #fff;\n  border-radius: 12px;\n  padding: 15px 20px;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06);\n  border-left: 5px solid #0668f9;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.masterpage-card:hover {\n  transform: scale(1.02);\n  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);\n}\n\n.masterpage-card-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.masterpage-card-checkbox input {\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #40c057;\n  border-radius: 50%;\n  cursor: pointer;\n  position: relative;\n  transition: background-color 0.2s ease;\n}\n\n.masterpage-card-checkbox input:checked {\n  background-color: #40c057;\n}\n\n.masterpage-card-checkbox input:checked::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background-color: white;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.masterpage-card-checkbox strong {\n  color: #212529;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.masterpage-card p {\n  margin: 8px 0;\n  color: #495057;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.masterpage-card p strong {\n  color: #343a40;\n  font-weight: 500;\n  min-width: 100px;\n}\n\n.masterpage-card p span {\n  color: #6c757d;\n  flex: 1;\n  word-break: break-word;\n}\n\n@media (max-width: 768px) {\n  .masterpage-wrapper {\n    padding: 15px;\n  }\n\n  .masterpage-header {\n    padding: 12px 15px;\n  }\n\n  .masterpage-controls {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .masterpage-grid {\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  }\n}\n\n@media (max-width: 480px) {\n  .masterpage-header {\n    padding: 10px;\n  }\n\n  .masterpage-search-input {\n    max-width: 100%;\n  }\n\n  .masterpage-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .masterpage-card {\n    padding: 12px 15px;\n  }\n\n  .masterpage-card p {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .masterpage-card p strong {\n    min-width: auto;\n  }\n}\n\n.masterpage_table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.masterpage_table-scroll {\n  max-height: 400px;\n  overflow: auto;\n  border: 1px solid #ddd;\n}\n\n.masterpage_table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 900px;\n}\n\n.masterpage_table th,\n.masterpage_table td {\n  padding: 12px 3px;\n  text-align: left;\n  border: 1px solid #ddd;\n  white-space: nowrap;\n}\n\n.masterpage_table thead th {\n  position: sticky;\n  top: 0;\n  background: linear-gradient(90deg, #ff6b6b, #ff8e53);\n  color: white;\n  z-index: 2;\n}\n\n.masterpage_table-row:hover {\n  background-color: #f9f9f9;\n  transition: background-color 0.3s ease;\n}\n\n.masterpage_table-already-sent {\n  background-color: #f2f2f2 !important;\n  opacity: 0.6;\n}\n\n/* Responsive Tweaks */\n@media screen and (max-width: 768px) {\n  .masterpage_table th,\n  .masterpage_table td {\n    font-size: 12px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .masterpage_table th,\n  .masterpage_table td {\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
